import React from "react";
import DashboardLayout from "app/layout/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/layout/DashboardNavbar";
import Footer from "app/layout/Footer";
import MDBox from "shared/components/MDBox";
import { TablaTableroSac } from "./components/TablaTableroSac/TablaTableroSac";

const TableroSac = () => {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} />
      <MDBox mt={2} mb={0}>
        <TablaTableroSac />
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default TableroSac;
